import { SpanMaps } from './types'

export const twColSpan: SpanMaps = {
  sm: {
    1: 'ds-col-span-1',
    2: 'ds-col-span-2',
    3: 'ds-col-span-3',
    4: 'ds-col-span-4',
    5: 'ds-col-span-5',
    6: 'ds-col-span-6',
    7: 'ds-col-span-7',
    8: 'ds-col-span-8',
    9: 'ds-col-span-9',
    10: 'ds-col-span-10',
    11: 'ds-col-span-11',
    12: 'ds-col-span-12'
  },
  md: {
    1: 'md:!ds-col-span-1',
    2: 'md:!ds-col-span-2',
    3: 'md:!ds-col-span-3',
    4: 'md:!ds-col-span-4',
    5: 'md:!ds-col-span-5',
    6: 'md:!ds-col-span-6',
    7: 'md:!ds-col-span-7',
    8: 'md:!ds-col-span-8',
    9: 'md:!ds-col-span-9',
    10: 'md:!ds-col-span-10',
    11: 'md:!ds-col-span-11',
    12: 'md:!ds-col-span-12'
  },
  lg: {
    1: 'lg:!ds-col-span-1',
    2: 'lg:!ds-col-span-2',
    3: 'lg:!ds-col-span-3',
    4: 'lg:!ds-col-span-4',
    5: 'lg:!ds-col-span-5',
    6: 'lg:!ds-col-span-6',
    7: 'lg:!ds-col-span-7',
    8: 'lg:!ds-col-span-8',
    9: 'lg:!ds-col-span-9',
    10: 'lg:!ds-col-span-10',
    11: 'lg:!ds-col-span-11',
    12: 'lg:!ds-col-span-12'
  }
}

export default twColSpan
